// extracted by mini-css-extract-plugin
export default {"Installation":"installation-module_Installation_Ibm9z"};